import { removeCurrencyMask } from '@helper/removeCurrentyMask'

export const parseUpdateFinalStorage = (value: string, data: any) => {
  return {
    ano: 2022,
    mes: data['empresa-mes'],
    empresaId: data['empresa-id'],
    categoriaId: data['categoria-id'],
    estoqueFinalAjustado: removeCurrencyMask(value)
    // categoria: {
    //   id: data['categoria-codigo-id'],
    //   descricao: data['categoria-descricao-id'],
    //   categoriaCompacta: {
    //     id: data['categoria-compacta-codigo-id'],
    //     descricao: data['categoria-compacta-descricao-id']
    //   },
    //   mundo: {
    //     id: 0,
    //     descricao: ''
    //   }
    // },
    // estoqueInicial: removeCurrencyMask(data['indicadores-estoque-inicial-id']),
    // recebimentosProgramados: removeCurrencyMask(
    //   data['indicadores-a-receber-id']
    // ),
    // vendasProjetadasPlanoDeCompra: removeCurrencyMask(
    //   data['indicadores-compra-projet-id']
    // ),
    // estoqueFinal: removeCurrencyMask(data['indicadores-estoque-final-id']),
    // otbPlanejamento: removeCurrencyMask(data['indicadores-planej-projet-id']),
    // estoqueFinalAjustado: removeCurrencyMask(value),
    // vendasProjetadasPCL: 0
  }
}
